// extracted by mini-css-extract-plugin
export default {"sliderIcon":"FormSection_sliderIcon__pKcB8","input":"FormSection_input__Z4Suo"};